import React from 'react';
import { DragSource } from 'react-dnd';
import ItemTypes from './ItemTypes';
import ID from './UUID.jsx';
import Tooltip from './components/Tooltip';

const cardSource = {
  beginDrag(props) {
    return {
      id: ID.uuid(),
      index: -1,
      data: props.item,
      onCreate: props.onCreate,
    };
  },
};

class ToolbarItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { connectDragSource, item, onClick } = this.props;
    if (!connectDragSource) return null;
    return connectDragSource(
      <li onClick={onClick} className="flex gap-2">
        <img alt="" src={item.icon} />
        <span>{item.name}</span>
      </li>,
    );
  }
}

export default DragSource(ItemTypes.CARD, cardSource, connect => ({
  connectDragSource: connect.dragSource(),
}))(ToolbarItem);
